import DataTableContainer from './DataTable.container';

export default DataTableContainer;
